export default "__VITE_ASSET__Bsp_wskQ__"